import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';

import { MessageBannerComponent } from './message-banner.component';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

@NgModule({
  declarations: [MessageBannerComponent],
  exports: [MessageBannerComponent],
  imports: [CommonModule, ButtonModule, IconModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class MessageBannerModule {}
